import { CreditUsageType } from '../definition';

export const CreditUsageTitle: Record<CreditUsageType, string> = {
  CONTACT_STORAGE_BASIC: 'Basic Person Storage',
  ACCOUNT_STORAGE_BASIC: 'Basic Account Storage',
  ACCOUNT_STORAGE_AI: 'Lookalike Account Storage',
  CONTACT_STORAGE_AI: 'Contact Storage AI',
  CONTACT_ANALYSIS_REVEAL: 'AI Profile Analysis',
  CONTACT_PROFILE_REVEAL: 'Full Profile Enrichment',
  CONTACT_EMAIL_FINDING: 'Valid Email Found',
  CONTACT_ANALYSIS_UPDATE: 'Analysis Update',
  CONTACT_PROFILE_UPDATE: 'Full Profile Update', // new
  CONTACT_EMAIL_GUESS_RETRIEVAL: 'Email Guess Retrieval',
  CONTACT_EMAIL_REVERIFICATION: 'Email Re-Verification',
  CONTACT_PHONE_FINDING: 'Valid Phone Found',
  ACCOUNT_STORAGE_ENRICH: 'Account Storage Enrichment',
  CONTACT_STORAGE_ENRICH: 'Contact Storage Enrichment',
};
